'use client'

import { Faq, html } from '@ensemble.music/ui'
import { faq } from './content'
import { SectionHeading } from './SectionHeading'

export function FaqSection() {
  return (
    // custom classes stay on plain DOM elements (see HowItWorks): the head sits beside the
    // accordion here instead of above it, and the smallest H2 on the page - the answers are the
    // content of this block, not its title.
    <section
      id="fragen"
      className="landing-faq"
    >
      <div className="landing-faq-head">
        <SectionHeading
          size="sm"
          title="Häufige Fragen"
          lead="Fehlt etwas? Schreib uns einfach."
        />
      </div>

      <html.div className="flex flex-col grow min-w-0">
        <Faq items={faq} />
      </html.div>
    </section>
  )
}

/** The same questions as structured data, built from the same array so they cannot drift apart. */
export function faqJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  }
}
